import { MapEntity } from '../types/MapEntity.type';

export type StageDef = {
  title: string;
  entities?: MapEntity[];
  goalY: number;
  zoomY: number;
};

export const stages: StageDef[] = [
  {
    title: 'Chzzk Cheese Road',
    goalY: 245,
    zoomY: 230,
    entities: [
      // 왼쪽 벽
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          points: [
            [8, -300],
            [8, 30],
            [3, 35],
            [3, 60],
            [7, 64],
            [7, 90],
            [3, 94],
            [3, 120],
            [7, 124],
            [7, 150],
            [3, 154],
            [3, 180],
            [7, 184],
            [7, 210],
            [4, 213],
            [4, 235],
            [13.5, 241],
            [13.5, 247],
          ],
        },
      },
      // 오른쪽 벽
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          points: [
            [18, -300],
            [18, 30],
            [23, 35],
            [23, 60],
            [19, 64],
            [19, 90],
            [23, 94],
            [6, 110],
            [23, 120],
            [19, 124],
            [19, 150],
            [23, 154],
            [23, 180],
            [19, 184],
            [19, 210],
            [22, 213],
            [22, 235],
            [14.5, 241],
            [14.5, 247],
          ],
        },
      },
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          points: [
            [10, 165],
            [17, 168],
            [17, 172],
            [10, 175],
          ],
        },
      },
      // 좁은 골인 지점 - 회전 바 (Wheel of fortune 스타일)
      {
        position: { x: 12.3, y: 241.5 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: -1.2, restitution: 0 },
      },
      // 회전 바퀴들 (치즈 구멍 느낌)
      {
        position: { x: 10, y: 20 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: 3.5, restitution: 0 },
      },
      {
        position: { x: 16, y: 20 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: -3.5, restitution: 0 },
      },
      {
        position: { x: 6, y: 60 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -4, restitution: 0 },
      },
      {
        position: { x: 20, y: 60 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 10, y: 100 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: 5, restitution: 0 },
      },
      {
        position: { x: 16, y: 100 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: -5, restitution: 0 },
      },
      {
        position: { x: 6, y: 140 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -3.5, restitution: 0 },
      },
      {
        position: { x: 20, y: 140 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: 3.5, restitution: 0 },
      },
      {
        position: { x: 13, y: 185 },
        type: 'kinematic',
        shape: { type: 'box', width: 7.5, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 13, y: 220 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -8, restitution: 0 },
      },
      // 초입 static 바
      {
        position: { x: 14, y: 40 },
        type: 'static',
        shape: { type: 'box', width: 7.5, height: 0.1, rotation: -110.1, color: '#00FFA3' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      {
        position: { x: 12, y: 45 },
        type: 'static',
        shape: { type: 'box', width: 9, height: 0.1, rotation: 110.06, color: '#00FFA3' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      {
        position: { x: 20.5, y: 48 },
        type: 'static',
        shape: { type: 'box', width: 2.5, height: 0.1, rotation: -110.06, color: '#00FFA3' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      // 치즈 구멍 (튕기는 원형 장애물)
      {
        position: { x: 13, y: 30 },
        type: 'static',
        shape: { type: 'circle', radius: 1.5, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 9, y: 50 },
        type: 'static',
        shape: { type: 'circle', radius: 1.2, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 13, y: 50 },
        type: 'static',
        shape: { type: 'circle', radius: 1.2, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 17, y: 50 },
        type: 'static',
        shape: { type: 'circle', radius: 1.2, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 13, y: 70 },
        type: 'static',
        shape: { type: 'circle', radius: 1.8, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 10, y: 90 },
        type: 'static',
        shape: { type: 'circle', radius: 1.0, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 16, y: 90 },
        type: 'static',
        shape: { type: 'circle', radius: 1.0, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 9, y: 130 },
        type: 'static',
        shape: { type: 'circle', radius: 1.0, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 17, y: 130 },
        type: 'static',
        shape: { type: 'circle', radius: 1.0, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 13, y: 150 },
        type: 'static',
        shape: { type: 'circle', radius: 1.3, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 8, y: 170 },
        type: 'static',
        shape: { type: 'circle', radius: 0.8, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 18, y: 170 },
        type: 'static',
        shape: { type: 'circle', radius: 0.8, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 13, y: 190 },
        type: 'static',
        shape: { type: 'circle', radius: 1.0, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 10, y: 210 },
        type: 'static',
        shape: { type: 'circle', radius: 0.6, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      {
        position: { x: 16, y: 210 },
        type: 'static',
        shape: { type: 'circle', radius: 0.6, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 },
      },
      // 작은 다이아몬드 장애물 (Wheel of fortune 스타일)
      {
        position: { x: 10, y: 35 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 13, y: 35 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 16, y: 35 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 9, y: 65 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 65 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 65 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 65 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 10, y: 95 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 13, y: 95 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 16, y: 95 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 9, y: 135 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 135 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 135 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 135 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 175 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 13, y: 175 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 175 },
        type: 'static',
        shape: { type: 'box', width: 0.25, height: 0.25, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 205 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 207 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 11, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 203 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 201 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 199 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 197 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 11, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 195 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 11, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 15, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 9, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 7, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 19, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
            {
        position: { x: 13, y: 193 },
        type: 'static',
        shape: { type: 'box', width: 0.3, height: 0.3, rotation: 45, color: '#FFEB3B' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      // 지그재그 핀들 (Yoru ni Kakeru 스타일)
      {
        position: { x: 10, y: 55 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 12, y: 55 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 55 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 55 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 11, y: 57 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 13, y: 57 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 15, y: 57 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 4, y: 115 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 6, y: 115 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 8, y: 115 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 115 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 5, y: 117 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 7, y: 117 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 9, y: 117 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 6, y: 235.5 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 5, life: 1 },
      },
      {
        position: { x: 8, y: 236.7 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 5, life: 1 },
      },
      {
        position: { x: 10, y: 237.9 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 5, life: 1 },
      },
      {
        position: { x: 14, y: 242},
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 242.2},
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 242.4},
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 155 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 12, y: 155 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 155 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 155 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 11, y: 157 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 13, y: 157 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 15, y: 157 },
        type: 'static',
        shape: { type: 'circle', radius: 0.4, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 8, y: 195 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 195 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 12, y: 195 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 195 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 195 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 18, y: 195 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 12, y: 197 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 197 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 8, y: 197 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 18, y: 197 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 12, y: 203 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 203 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 203 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 203 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 8, y: 200 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 200 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 12, y: 200 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 200 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 200 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 18, y: 200 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      // 경사진 바 (Yoru ni Kakeru 스타일)
      {
        position: { x: 10, y: 75 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.1, rotation: 30, color: '#FFFFFF' },
        props: { density: 1, angularVelocity: 0.5, restitution: 0 },
      },
      {
        position: { x: 16, y: 75 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.1, rotation: -30, color: '#FFFFFF' },
        props: { density: 1, angularVelocity: -0.5, restitution: 0 },
      },
      {
        position: { x: 10, y: 145 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.1, rotation: -20, color: '#FFFFFF' },
        props: { density: 1, angularVelocity: 0.4, restitution: 0 },
      },
      {
        position: { x: 16, y: 145 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.1, rotation: 20, color: '#FFFFFF' },
        props: { density: 1, angularVelocity: -0.4, restitution: 0 },
      },
      // 추가 작은 원형 장애물들
      {
        position: { x: 11, y: 78 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.4, life: 1 },
      },
      {
        position: { x: 13, y: 78 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.4, life: 1 },
      },
      {
        position: { x: 15, y: 78 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.4, life: 1 },
      },
      {
        position: { x: 11, y: 148 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.4, life: 1 },
      },
      {
        position: { x: 13, y: 148 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.4, life: 1 },
      },
      {
        position: { x: 15, y: 148 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.4, life: 1 },
      },
      // 큰 박스 장애물 (BubblePop 스타일)
      {
        position: { x: 9, y: 25 },
        type: 'static',
        shape: { type: 'box', width: 2.5, height: 2.5, rotation: 60, color: '#FFEAA7' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 17, y: 25 },
        type: 'static',
        shape: { type: 'box', width: 2.5, height: 2.5, rotation: 50, color: '#FFEAA7' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      {
        position: { x: 13, y: 125 },
        type: 'static',
        shape: { type: 'box', width: 3, height: 3, rotation: 45, color: '#FFEAA7' },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
      },
      // 최종 구간 회전 바
      {
        position: { x: 7, y: 225 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      {
        position: { x: 19, y: 225 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: 10, restitution: 0 },
      },
      {
        position: { x: 14, y: 232 },
        type: 'kinematic',
        shape: { type: 'box', width: 4, height: 0.1, rotation: 0, color: '#FFD700' },
        props: { density: 1, angularVelocity: -6, restitution: 0 },
      },
      {
        position: { x: 7, y: 215 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      {
        position: { x: 19, y: 215 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: 10, restitution: 0 },
      },
      {
        position: { x: 13, y: 225 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      {
        position: { x: 13, y: 215 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: 10, restitution: 0 },
      },
      {
        position: { x: 7, y: 220 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -10, restitution: 0 },
      },
      {
        position: { x: 19, y: 220 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: 10, restitution: 0 },
      },
      // 튕기는 영구적 원
      {
        position: { x: 4, y: 235.2 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#FFEB3B' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5},
      },
      {
        position: { x: 8, y: 237.7 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#FFEB3B' },
        props: { angularVelocity: 0, density: 1, restitution: 2},
      },
      {
        position: { x: 11, y: 239.6 },
        type: 'static',
        shape: { type: 'circle', radius: 0.35, color: '#FFEB3B' },
        props: { angularVelocity: 0, density: 1, restitution: 1.5},
      },
    ],
  },
  {
    title: 'Chzzk Cheese Rolling',
    goalY: 120,
    zoomY: 110,
    entities: [
      // 왼쪽 벽
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          points: [
            [8, -300],
            [8, 25],
            [3, 30],
            [3, 40],
            [17, 50],
            [3, 60],
            [5, 70],
            [12, 84],
            [3, 100],
            [10,110],
            [13,120],
            [13,122],
          ],
        },
      },
      // 오른쪽 벽
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          points: [
            [18, -300],
            [18, 25],
            [6, 35],
            [23, 45],
            [21, 50],
            [7, 64],
            [18, 80],
            [20, 86],
            [18, 94],
            [8, 100],
            [18, 110],
            [15, 120],
            [15, 122],
          ],
        },
      },
      // 결승 지점 회전 바 (y=117 부근)
      {
        position: { x: 14, y: 114 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.1, rotation: 0, color: '#FFA500' },
        props: { density: 1, angularVelocity: -6, restitution: 0 },
      },
      // 경사진 선에 걸친 튕기는 원형들
      // 경사 구간)
      { position: { x: 9, y: 11 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 11, y: 12 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 13, y: 13 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 15, y: 14 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 17, y: 15 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 9, y: 17 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 11, y: 18 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 13, y: 19 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 15, y: 20 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 17, y: 21 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 9, y: 23 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 11, y: 24 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 13, y: 25 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 15, y: 26 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },


      { position: { x: 9, y: 41 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 11, y: 42 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 13, y: 43 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 15, y: 44 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 17, y: 45 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },

      { position: { x: 9, y: 58.5 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 11, y: 57 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 13, y: 55.5 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 15, y: 54 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 17, y: 52.5 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },

      { position: { x: 5, y: 100 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 7, y: 103 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 9, y: 106 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 11, y: 109 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#00FFA3' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 13, y: 112 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },

      { position: { x: 13, y: 116 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 14, y: 116 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      { position: { x: 15, y: 116 }, type: 'static', shape: { type: 'circle', radius: 0.3, color: '#704CE5' }, props: { angularVelocity: 0, density: 1, restitution: 1.5, life: 1 } },
      // 선에 걸친 원형들
      { position: { x: 14, y: 28.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 29.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 12, y: 30.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 11, y: 30.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 10, y: 31.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 9, y: 32.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 8, y: 33.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 28.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 29.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 12, y: 29.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 11, y: 30.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 10, y: 31.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 9, y: 32.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 8, y: 33.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },

      { position: { x: 16, y: 49.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 15, y: 48.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 48 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 47   }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 12, y: 46.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 11, y: 46 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 10, y: 45 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 9, y: 44.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 8, y: 43.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 7, y: 42.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 6, y: 42.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 5, y: 41.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 4, y: 40.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 16, y: 49.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 15, y: 48.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 47.8 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 46.8   }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 12, y: 46.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 11, y: 45.8 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 10, y: 44.8 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 9, y: 44.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 8, y: 43.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 7, y: 42.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 6, y: 41.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 5, y: 41.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 4, y: 40.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },

      { position: { x: 16, y: 95.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 15, y: 95.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 96.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 97.1   }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 12, y: 97.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 11, y: 98.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 10, y: 98.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 9, y: 99.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 8, y: 100.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 7, y: 100.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 6, y: 101.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 5, y: 101.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 16, y: 95.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 15, y: 95.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 96.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 96.9   }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 12, y: 97.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 11, y: 98.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 10, y: 98.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 9, y: 99.3 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 8, y: 99.9 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 7, y: 100.5 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 6, y: 101.1 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 5, y: 101.7 }, type: 'static', shape: { type: 'circle', radius: 0.4, color: '#FFA500' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },

      // 큰 원
      { position: { x: 13, y: 92 }, type: 'static', shape: { type: 'circle', radius: 3.5, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 92 }, type: 'static', shape: { type: 'circle', radius: 3.0, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 92 }, type: 'static', shape: { type: 'circle', radius: 2.5, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 13, y: 92 }, type: 'static', shape: { type: 'circle', radius: 2, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },

      { position: { x: 14, y: 120 }, type: 'static', shape: { type: 'circle', radius: 1.5, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 120 }, type: 'static', shape: { type: 'circle', radius: 1.8, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 120 }, type: 'static', shape: { type: 'circle', radius: 2, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 120 }, type: 'static', shape: { type: 'circle', radius: 2.2, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
      { position: { x: 14, y: 120 }, type: 'static', shape: { type: 'circle', radius: 2.5, color: '#FFFFFF' }, props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 } },
    ],
  },
  {
    title: 'Chzzk Spinning Log',
    goalY: 60,
    zoomY: 55,
    entities: [
      // 왼쪽 벽
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          color: '#FFFFFF',
          bloomColor: '#00FFA3',
          points: [
            [8, -300],
            [8, 10],
            [6, 15],
            [6, 30],
            [8, 35],
            [8, 50],
            [8, 52],
            [13.5, 58],
            [13.5, 62],
          ],
        },
      },
      // 오른쪽 벽
      {
        type: 'static',
        position: { x: 0, y: 0 },
        props: { density: 1, angularVelocity: 0, restitution: 0 },
        shape: {
          type: 'polyline',
          rotation: 0,
          color: '#FFFFFF',
          bloomColor: '#00FFA3',
          points: [
            [18, -300],
            [18, 10],
            [20, 15],
            [20, 30],
            [18, 35],
            [18, 50],
            [16, 55],
            [14.5, 58],
            [14.5, 62],
          ],
        },
      },
      // 많은 회전 바들 (통나무 느낌 - 밝은 갈색 #D2691E)
      // 초반 구간 (y=5~15)
      {
        position: { x: 10, y: 5 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 3, restitution: 0 },
      },
      {
        position: { x: 16, y: 5 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -3, restitution: 0 },
      },
      {
        position: { x: 13, y: 8 },
        type: 'kinematic',
        shape: { type: 'box', width: 4, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 10, y: 11 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -5, restitution: 0 },
      },
      {
        position: { x: 16, y: 11 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 5, restitution: 0 },
      },
      {
        position: { x: 13, y: 14 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: -4, restitution: 0 },
      },
      // 중반 구간 (y=17~30)
      {
        position: { x: 10, y: 17 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 3, restitution: 0 },
      },
      {
        position: { x: 16, y: 17 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -3, restitution: 0 },
      },
      {
        position: { x: 13, y: 20 },
        type: 'kinematic',
        shape: { type: 'box', width: 6, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 11, y: 23 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -4, restitution: 0 },
      },
      {
        position: { x: 15, y: 23 },
        type: 'kinematic',
        shape: { type: 'box', width: 2.5, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 13, y: 26 },
        type: 'kinematic',
        shape: { type: 'box', width: 5, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: -4, restitution: 0 },
      },
      {
        position: { x: 11, y: 29 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 2, restitution: 0 },
      },
      {
        position: { x: 15, y: 29 },
        type: 'kinematic',
        shape: { type: 'box', width: 3, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -2, restitution: 0 },
      },
      // 중후반 구간 (y=32~45)
      {
        position: { x: 13, y: 32 },
        type: 'kinematic',
        shape: { type: 'box', width: 5, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 9, y: 35 },
        type: 'kinematic',
        shape: { type: 'box', width: 1, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -1, restitution: 0 },
      },
      {
        position: { x: 17, y: 35 },
        type: 'kinematic',
        shape: { type: 'box', width: 1, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 1, restitution: 0 },
      },
      {
        position: { x: 13, y: 38 },
        type: 'kinematic',
        shape: { type: 'box', width: 4.5, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: -4, restitution: 0 },
      },
      {
        position: { x: 10, y: 41 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 5, restitution: 0 },
      },
      {
        position: { x: 16, y: 41 },
        type: 'kinematic',
        shape: { type: 'box', width: 2, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -5, restitution: 0 },
      },
      {
        position: { x: 13, y: 44 },
        type: 'kinematic',
        shape: { type: 'box', width: 4.7, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      // 후반 구간 (y=47~60)
      {
        position: { x: 9, y: 47 },
        type: 'kinematic',
        shape: { type: 'box', width: 1, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -6, restitution: 0 },
      },
      {
        position: { x: 17, y: 47 },
        type: 'kinematic',
        shape: { type: 'box', width: 1, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 6, restitution: 0 },
      },
      {
        position: { x: 13, y: 50 },
        type: 'kinematic',
        shape: { type: 'box', width: 4.7, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: -1.5, restitution: 0 },
      },
      {
        position: { x: 11, y: 53 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -2, restitution: 0 },
      },
      {
        position: { x: 15, y: 53 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.5, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: 2, restitution: 0 },
      },
      {
        position: { x: 13, y: 55 },
        type: 'kinematic',
        shape: { type: 'box', width: 1, height: 0.15, rotation: 0, color: '#CD853F' },
        props: { density: 1, angularVelocity: 4, restitution: 0 },
      },
      {
        position: { x: 12.5, y: 58 },
        type: 'kinematic',
        shape: { type: 'box', width: 1.8, height: 0.15, rotation: 0, color: '#D2691E' },
        props: { density: 1, angularVelocity: -1.2, restitution: 0 },
      },
      // 장식용 고정 원형들 (chzzk 색상 사용)
      {
        position: { x: 13, y: 7 },
        type: 'static',
        shape: { type: 'circle', radius: 0.5, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.2, life: 1 },
      },
      {
        position: { x: 13, y: 16 },
        type: 'static',
        shape: { type: 'circle', radius: 0.5, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.2, life: 1 },
      },
      {
        position: { x: 13, y: 25 },
        type: 'static',
        shape: { type: 'circle', radius: 0.5, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.2, life: 1 },
      },
      {
        position: { x: 13, y: 34 },
        type: 'static',
        shape: { type: 'circle', radius: 0.5, color: '#00FFA3' },
        props: { angularVelocity: 0, density: 1, restitution: 1.2, life: 1 },
      },
      {
        position: { x: 13, y: 43 },
        type: 'static',
        shape: { type: 'circle', radius: 0.5, color: '#FFFFFF' },
        props: { angularVelocity: 0, density: 1, restitution: 1.2, life: 1 },
      },
      {
        position: { x: 13, y: 52 },
        type: 'static',
        shape: { type: 'circle', radius: 0.5, color: '#704CE5' },
        props: { angularVelocity: 0, density: 1, restitution: 1.2, life: 1 },
      },
      // 작은 장식 원형들
      {
        position: { x: 10, y: 10 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 10 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFA500' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 22 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 22 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFA500' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 34 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 34 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFA500' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 10, y: 46 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 16, y: 46 },
        type: 'static',
        shape: { type: 'circle', radius: 0.3, color: '#FFA500' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 58 },
        type: 'static',
        shape: { type: 'circle', radius: 1, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 58 },
        type: 'static',
        shape: { type: 'circle', radius: 1.2, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
      {
        position: { x: 14, y: 58 },
        type: 'static',
        shape: { type: 'circle', radius: 1.4, color: '#FFD700' },
        props: { angularVelocity: 0, density: 1, restitution: 1.3, life: 1 },
      },
    ],
  },
];
